import styled, { keyframes } from "styled-components";

const progress = keyframes`
	from {
		transform: rotate(0deg) skewX(30deg);
	}
	to {
		transform: rotate(360deg) skewX(30deg);
	}
`;

const Circle = styled.div`
  position: relative;
  margin-top: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: transparent;
`;

const Arc = styled.div`
  overflow: hidden;
  position: absolute;
  top: -1px;
  left: -1px;
  right: 50%;
  bottom: 50%;
  transform-origin: 100% 100%;
  animation: ${progress} 2s ease-in-out infinite;

  &:before {
    box-sizing: border-box;
    display: block;
    border: solid 5px #88bfd3;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    transform: skewX(-30deg);
    content: "";
  }
`;

const LoadingCircle = () => {
  return (
    <Circle>
      <Arc />
    </Circle>
  );
};

export default LoadingCircle;
